/**
 * Created by phatbass on 2/9/16.
 */

angular.module('far.events')
    .controller('EventUsersController', function ($log, $scope, $http, $window, form, autocomplete, formsUtils, inviteUserForm, http) {
        var vm = {
            loaded: true,
            submitted: false,
            eventQualifications: [],
            eventUsersSearchModel: {},
            users: {
                offset: 0,
                limit: 500,
                data: [],
                id: {}
            },
            usersSelect: {},
            usersInvite: [],
            selectAll: false,
            selectAllFunc: function () {
                if (vm.selectAll) {
                    vm.usersSelect = angular.copy(vm.users.id);
                } else {
                    vm.usersSelect = {};
                }
            },
            total: {
                count: null,
                pages: null
            },
            eventUsersSearchForm: form('eventUsersSearchForm'),
            eventUsersInviteForm: form('eventUsersInviteForm'),
            search: function (next) {
                if ($scope.eventUsersSearchForm.$invalid || vm.submitted) {
                    return;
                }

                if (!next) {
                    vm.users.offset = 0;
                    vm.users.data = [];
                    vm.total.count = null;
                    vm.total.pages = null;
                }

                var data = angular.merge({}, vm.eventUsersSearchModel);
                data.member = +data.member;
                data['offset'] = vm.users.offset;
                data['limit'] = vm.users.limit;

                vm.submitted = true;

                vm.usersSelect = {};

                $http.get(Routing.generate('api_event_event_users_search', data)).then(function (response) {
                    vm.total.count = response.headers('X-Total-Count');
                    vm.total.pages = Math.ceil(vm.total.count / vm.users.limit);

                    for (var id in response.data) {
                        response.data[id]['url'] = Routing.generate('user_view', {userId: response.data[id].id});

                        if (vm.eventQualifications.length) {
                            if (response.data[id].qualification) {
                                if (vm.eventQualifications.indexOf(response.data[id].qualification.id) != -1) {
                                    response.data[id]['show'] = true;
                                }
                            }
                        } else {
                            response.data[id]['show'] = true;
                        }

                        vm.users.data.push(response.data[id]);
                        vm.users.id[id] = response.data[id].id;
                    }

                    vm.submitted = false;
                }, function errorCallback(response) {
                    response = http.authenticationListener(response);

                    $log.error(response);

                    vm.submitted = false;
                });
            },
            add: function (id) {
                if (vm.submitted) {
                    return false;
                }

                /*
                 if ( !$scope.membershipForm.$valid ) {
                 return false;
                 }
                 */
                vm.submitted = true;

                $http.post(Routing.generate('api_event_post_event_users_add', {id: id}), {
                    event_users: vm.usersSelect,
                    users_invite: vm.usersInvite
                }).then(function (response) {
                    $window.location.reload(true);
                }, function errorCallback(response) {
                    response = http.authenticationListener(response);

                    $log.error(response);

                    vm.submitted = false;
                });
            },
            next: function () {
                vm.users.offset += vm.users.limit;

                vm.submit(true);
            },
            getTotalCount: function () {
                return formsUtils.numEnding(vm.total.count, ['Найден', 'Найдено', 'Найдено']) + ' ' + vm.total.count + ' ' + formsUtils.numEnding(vm.total.count, ['человек', 'человека', 'человек']);
            }
        };

        vm.eventUsersSearchForm
            .addField('user_city', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-350'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Город',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "UserCity", "user_city")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        if (item) {
                            vm.eventUsersSearchModel.user_city = item.name;
                        }
                    }
                }
            }, autocomplete.get('user_city'))
            .addField('club', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-450'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Федерация/Клуб',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Club", "club")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        vm.eventUsersSearchModel.club = item.id;
                    }
                }
            }, autocomplete.get('club'))
            .addField('member', 'checkbox', {
                validators: {
                    required: false
                },

                label: 'Члены ФАР'
            })
            .addField('q', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Имя, фамилия, отчество',
                    class: 'form__item width-450'
                }
            })
        ;

        vm.eventUsersInviteForm
            .addField('users_invite', 'collection', {
                validators: {
                    required: false
                },
                label: 'Пригласить участника',
                buttons: {
                    add: 'Пригласить участника',
                    remove: 'Удалить участника'
                }
            }, inviteUserForm)
        ;

        return vm;
    });
